import axios from "axios";
import MockAdapter from "axios-mock-adapter";
import * as url from "../url_helper";

let users = [
  {
    uid: 1,
    username: "Stevens L.",
    role: "admin",
    password: "123456",
    email: "pixeleyez@admin.com",
  },
];

const fakeBackend = () => {
  // This sets the mock adapter on the default instance
  const mock = new MockAdapter(axios, { onNoMatch: "passthrough" });

  // login
  mock.onPost(url.POST_FAKE_LOGIN).reply((config : any) => {
    const { email, password } = JSON.parse(config.data); 

    const validUser = users.filter(
      (usr) => usr.email === email && usr.password === password
    );
    
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        if (validUser["length"] === 1) {
          resolve([200, validUser[0]]);
        } else {
          reject([
            "Username and password are invalid. Please enter correct username and password",
          ]);
        }
      });
    });
  });

  // register
  mock.onPost(url.POST_FAKE_REGISTER).reply((config: any) => {
    const user = JSON.parse(config["data"]);
    users.push(user);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve([200, user]);
      });
    });
  });
};

export default fakeBackend;
